// @flow
import type { Element } from 'react';

import classNames from 'classnames';
import React from 'react';
import sharedTipsById from '@hbrisk/sp3-risk-model-support/models/tips/index.js';
import BaseTip from '#components/support/tooltips/Tip/BaseTip/index.jsx';
import extraTipsById from '#components/support/tooltips/Tip/tips/index.jsx';

type Props = {|
  className?: string | null,
  targetId?: string | null,
  tipId: string,
|};

const Tip = ({
  className = null,
  targetId = null,
  tipId,
}: Props): Element<typeof BaseTip> | null => {
  const sharedTip = sharedTipsById[tipId];
  const extraTip = extraTipsById[tipId];
  if (!sharedTip && !extraTip) {
    return null;
  }
  const header = (sharedTip && sharedTip.header) || (extraTip && extraTip.header);
  const definition = sharedTip && sharedTip.aiDefinition;
  const extras = extraTip && extraTip.body;

  let body = null;
  if (definition && extras) {
    body = (
      <>
        <p>{definition}</p>
        {extras}
      </>
    );
  } else if (definition) {
    body = <p>{definition}</p>;
  } else if (extras) {
    body = extras;
  }

  if (!body) {
    return null;
  }

  return (
    <BaseTip
      className={classNames('tip', className)}
      targetId={targetId}
      tipId={tipId}
      body={body}
      header={header}
    />
  );
};

export default Tip;
